export default {
  SET_BOOKING_CHANNELS (state, booking_channels) {
    state.booking_channels = booking_channels
  },
  REMOVE_RECORD (state, itemId) {
    const channelManagerIndex = state.booking_channels.findIndex((u) => u.id === itemId)
    state.booking_channels.splice(channelManagerIndex, 1)
  }
}
